import { gql } from "@apollo/client";

/**
 * IoT values of one asset location straight from the search index (IBM-1053):
 * one cheap request that never hops into the IoT subgraph, so the dashboard
 * hero can paint connection status, hub, firmware and SLA right away. The
 * index can lag behind (e.g. right after connecting or commissioning), so the
 * live entity queries keep running and win as soon as they answer. Only
 * current asset locations are indexed — no result simply means "unknown".
 *
 * The SLA fields only exist on gateways with the SLA backend; they are
 * included only while REACT_APP_ENABLE_SLA is on.
 */
export const AssetIndexIotSnapshot = gql`
    query AssetIndexIotSnapshot($id: ID!, $withSla: Boolean!) {
        searchAssets(filter: { assetLocationId: { equals: $id } }) {
            searchAssetResults(pagination: { start: 0, limit: 1 }) {
                id
                attributes {
                    iotConnectionStatus
                    iotHubConnectivityStatus
                    firmwareVersion
                    modemFirmwareVersion
                    iotSlaStatus @include(if: $withSla)
                    iotSlaLevel @include(if: $withSla)
                    iotConnectivityQuality @include(if: $withSla)
                }
            }
        }
    }
`;
